export default __webpack_public_path__ + "static/media/cyan.7712de7d.svg";